import React from "react";
import { getJSONFromAttribute } from "../Shared/Utils";
import { getAccessToken, refreshAccessToken, updateSettings } from "../Settings";
import domready from "domready";
import { createRoot } from "react-dom/client";
import { configureStore } from "@reduxjs/toolkit";
import { apiMiddleware } from "redux-api-middleware";
import { createApiCallReducer } from "../ApiCalls/ApiCallReducer";
import { Provider } from "react-redux";
import { loadStops } from "../Search/Actions";
import { Alert, Col, Row } from "react-bootstrap";
import { SpinnerSmall } from "../../Shared/Components/Spinner";
import { IAppSettings, useStateSelector } from "./Model";
import { createSkinetworksreducer } from "./Reducer";
import { SetStore } from "../ApiCalls/Utils";
import { CustomerDetails, SearchForm } from "./SearchAndCustomerDetails";
import { SearchResult } from "./SearchResult";
import { IRouteLeg, ITravel } from "../Models";

let containerElement: HTMLElement|null;

const App = () => {
	const state = useStateSelector(state => state.booking);

	if (!state.stops)
		return <Alert variant="info">Loading stops...<SpinnerSmall /></Alert>

	return <div className="body reservation-dialog">
		<Row>
			<Col xs={12} lg={8}>
				<SearchForm />
				<CustomerDetails show={state.travels ? true : false} />
			</Col>
			<Col xs={12} lg={4}>
				<SearchResult />
			</Col>
		</Row>
	</div>


};

export const findRelevantLeg = (travel: ITravel) : IRouteLeg|null => {
	return travel?.routes?.length > 0 ? travel?.routes[0].legs.find(x => x.serviceName === "304" || x.serviceName === "305") : null;
}

domready(() => {
	containerElement = document.getElementById("skinetworks-app");

	if (!containerElement)
		return;

	const settings = getJSONFromAttribute<IAppSettings>(containerElement, "data-settings", undefined);
	updateSettings(settings);

	const searchParams = new URLSearchParams(window?.location.search);
	const from = searchParams.get("from");
	const to = searchParams.get("to");
	let date = searchParams.get("date");
	let rdate = searchParams.get("rdate");


	const initialState = {
		allowedFrom: settings.from,
		allowedTo: settings.to,
		defaultFrom: from,
		defaultTo: to,
		departureDate: date,
		returnDate: rdate,
		lunchOptions: settings.lunchOptions,
		dinnerOptions: settings.dinnerOptions
	};

	const store = configureStore({
		reducer: {
			booking: createSkinetworksreducer(initialState),
			apicalls: createApiCallReducer()
		} ,
		middleware: (getDefaultMiddleware) => [apiMiddleware, ...getDefaultMiddleware({ serializableCheck: true })],
		devTools: {name: "Skinetworks"}
	});

	SetStore(store);

	setTimeout(async () => {
		await getAccessToken();
		store.dispatch(loadStops());
	}, 0);

	// Uppdatera api token var 10 minut (den räcker eg. i 30 min)
	setInterval(async () => await refreshAccessToken(), 10 * 60 * 1000);

	const root = createRoot(containerElement);
	root.render(
		<Provider store={store}>
			<App />
		</Provider>);
});